var DualRowPackageWithDifferentPadsData = require('./dualRowPackageWithDifferentPadsData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');

var Sot223Data = function(position, angle, init) {
    DualRowPackageWithDifferentPadsData.apply(this, arguments);
};

lib_core.inherit(Sot223Data, DualRowPackageWithDifferentPadsData);
lib_core.JsonParser.registerClass(Sot223Data, "Sot223Data");

module.exports = Sot223Data;

Sot223Data.prototype.getSilkscreen = function(pads) {
	var self = this;
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //TODO-CHECK: if number of pads in left side is less than 1 dont draw silkscreen
    if (self.component.padsPerSide[0] < 1) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = self.getBodyForSilkscreen();

    var leftFirstPad = pads[0],
        leftLastPad = pads[self.component.padsPerSide[0] - 1];

    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(leftFirstPad, body));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////

    var rightPad = pads[self.horizontalPadCount() - 1],
    	topEdge = leftFirstPad.getPos().y + leftFirstPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance,
    	botEdge = leftLastPad.getPos().y - leftLastPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance;

    var pathData;

    //if first left pad top edge crosses (with clearance) assembly outline top edge (with clearance) draw only top, down and right side lines
    if (topEdge + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
        pathData = new PathData(new lib_geometry.Coord(-body.width / 2, topEdge + IPCRules.silkscreenStrokeWidth / 2), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, topEdge + IPCRules.silkscreenStrokeWidth / 2), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, rightPad.getPos().y + rightPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), PathType.LINE));
        silkscreen.push(pathData);

        pathData = pathData.clone();
        pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
        silkscreen.push(pathData);
    } else {
        pathData = new PathData(new lib_geometry.Coord(-body.width / 2, topEdge), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, body.height / 2), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, body.height / 2), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, rightPad.getPos().y + rightPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), PathType.LINE));
        silkscreen.push(pathData);

        pathData = pathData.clone();
        pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
        silkscreen.push(pathData);
    }

    return silkscreen;
}